import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CityModal } from '../../domain/ciudades-modal.model';
import {
  API_CONFIG,
  BaseCrudService,
  buildSearchByTerm,
  PageResponse,
} from '@nebula-shared/data-access';

import { ApiResponse } from '@nebula-shared/domain';
@Injectable({ providedIn: 'root' })
export class CityService extends BaseCrudService<CityModal> {
  constructor() {
    super();
    const config = API_CONFIG.masters;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.ciudades}`);
  }

  /**
   * Método privado para hacer la petición POST al endpoint page-response
   */
  getAllCity(
    page: number,
    size: number,
    departamentoCodigo: string,
    searchTerm?: string,

    sortColumn?: string,
    sortDirection: 'ASC' | 'DESC' = 'ASC',
  ): Observable<PageResponse<CityModal>> {
    const searchsBy = [
      {
        key: 'estadoCiudad',
        operation: 'MATCH',
        value: 'ACTIVO',
        linkOperator: 'AND',
      },
      {
        key: 'departamentoCodigo',
        operation: 'MATCH',
        value: departamentoCodigo,
        linkOperator: 'AND',
      },
      ...buildSearchByTerm(searchTerm, [
        { key: 'codigo', type: 'text' },
        { key: 'nombre', type: 'text' },
      ]),
    ];

    const ordersBy: { column: string; direction: 'ASC' | 'DESC' }[] = [];
    if (sortColumn) {
      ordersBy.push({ column: sortColumn, direction: sortDirection });
    }

    const body = {
      page: page.toString(),
      size: size.toString(),
      ...(searchsBy.length > 0 && { searchsBy }),
      ...(ordersBy.length > 0 && { ordersBy }),
    };

    return this.getPageResponseRaw(page, size, body).pipe(
      map((response: ApiResponse<PageResponse<CityModal>>) => {
        const envelope = response?.response || response;
        const pageData = envelope?.content || envelope || {};

        return {
          size: pageData.size || size,
          number: pageData.number || page,
          numberOfElements: pageData.numberOfElements || pageData.content?.length || 0,
          totalElements: pageData.totalElements || 0,
          totalPages: pageData.totalPages || 0,
          content: pageData.content || [],
          empty: !pageData.content || pageData.content.length === 0,
        };
      }),
    );
  }
}
